<div class="flex min-h-[60px]">
   <div
      class="flex basic-shadow bg-app-primary-1  border-b-[6px] {{ project?.statusId | appStatutesBorderBottom }} {{
         (isSidebarOpen$ | async) ? 'w-[200px]' : 'w-[60px]'
      }} "
   >
      @if (isSidebarOpen$ | async) {
         <div
            @inOut
            class="w-[160px] pl-2 flex items-center gap-3 flex-1"
         >
            <span
               class="w-[50px] h-[45px] flex items-center justify-center"
               [inlineSVG]="project?.statusId | appStatutesIcons"
            ></span>
            <div class="flex flex-col text-white flex-1 min-w-0">
               <div class="text-[10px]">{{ 'status' | translate }}:</div>
               <div class="uppercase overflow-hidden text-ellipsis whitespace-nowrap text-[10px]">
                  {{ project?.statusId | appStatutes: (statutes$ | async) }}
               </div>
            </div>
         </div>
      }

      <div class="flex items-center justify-center w-[60px]">
         <i
            class="pi pi-bars text-sm text-white hover:opacity-50 cursor-pointer"
            (click)="toggleSidebar()"
         ></i>
      </div>
   </div>

   <div class="flex-1 bg-app-gray-3 flex items-center gap-2 pr-[15px] tablet:pr-8">
      <div class="flex flex-col pl-5 flex-1">
         <div class="text-xs">{{ 'project_title' | translate }}:</div>
         <span
            class="text-sm font-bold text-app-primary-1"
            style="line-height: 1.2"
            >{{ project?.title ?? '-' }}</span
         >
      </div>
      @if (allowEdit) {
         <div class="flex gap-3 items-end">
            <app-basic-progressbar
               class="flex"
               [ngClass]="(progress$ | async)?.isLoading ? 'w-[300px]' : 'hidden'"
               [progress$]="progress$"
            ></app-basic-progressbar>
            <p-menu
               #menu
               [popup]="true"
               [model]="items ?? []"
               appendTo="body"
               styleClass="status-topbar-menu"
            ></p-menu>
            <p-button
               styleClass="status-topbar-btn basic-accent-2-button w-[35px] h-[35px]"
               (click)="menu.toggle($event)"
            >
               <div
                  class="w-[30px] fill-app-accent-2"
                  [inlineSVG]="'/assets/icons/app-edit-project-icon.svg'"
               ></div>
            </p-button>
         </div>
      }
   </div>
</div>
